/* Disabling camelcase because backend/database fields are in snack_case */
/* eslint-disable camelcase */

import Ambitus from "../../ambitus/Ambitus";
import {Version} from "./Version";
import {Challenge} from "./Challenge";

export interface Piece {
  id: number,

  title: string,
  original_title: string,

  composer: string,
  artist: string,
  performer: string,
  arranger: string,
  writer: string,

  album_name: string,
  album_release_date: number
  record_label: string,
  publisher: string,

  tone: string,

  youtube_url: string,
  image: string,
  image_large: string,
  url_artist: string,
  url_title: string,

  language: string,
  catalog_type: string,

  "music_style": {
    "id": number
    "style": string,
  }

  published_versions: Version[] | null,
  challenges: Challenge[] | null,

  // TODO: use Ambitus object
  ambitus: Ambitus,
}

export const defaultPiece: Piece = {
  id: -1,
  title: "titre",
  original_title: "titre",
  composer: "composer",
  artist: "artist",
  performer: "performer",
  arranger: "arranger",
  writer: "writer",
  album_name: "album",
  album_release_date: 0,
  record_label: "label",
  publisher: "publisher",
  tone: "A",
  youtube_url: "https://www.youtube.com/watch?v=xh7wls1TxfA",
  image: "none", // TODO: Should we use a real default value ? > Yes because /none is not found
  image_large: "none", // TODO: Should we use a real default value ? > Yes because /none is not found
  url_artist: "url-artist",
  url_title: "url-title",
  language: "fr",
  catalog_type: "UNDER_LICENSE",

  "music_style": {
    "id": 8,
    "style": "Variété"
  },

  published_versions: null,
  challenges: null,

  ambitus: {
    low: 0,
    high: 88,
  },
}
